import { Component, Input } from '@angular/core';
import { LoggingInCard } from 'src/app/model/card/Logging-in-card';

@Component({
  selector: 'app-logging-in-card',
  templateUrl: './logging-in-card.component.html',
  styleUrls: ['./logging-in-card.component.scss']
})
export class LoggingInCardComponent {
  @Input() loggingInCards: LoggingInCard[] = [];
}
